// app.js — Client logic for Modzone Storefront (Connecting to backend API, Cart, Wishlist, Modals, Search, Currency)

// Dynamic API Base: works on localhost and live cloud (Render, Railway, etc.)
const API_BASE = window.MODZONE_API_BASE || 'https://backend-modzone-production.up.railway.app';


// State
let products = [];
let cart = JSON.parse(localStorage.getItem('mz_cart') || '[]');
let wishlist = JSON.parse(localStorage.getItem('mz_wishlist') || '[]');
let activeCategory = 'All';
let currentCurrency = localStorage.getItem('mz_currency') || 'USD';
let appliedDiscount = null; // { code: 'WELCOME15', percent: 15 } or null
let currentQvProduct = null;
let currentQvQty = 1;

// Currency conversion rates (relative to USD)
const CURRENCY_RATES = {
  USD: { symbol: '$', rate: 1.0 },
  PKR: { symbol: '₨ ', rate: 278.5 },
  AED: { symbol: 'AED ', rate: 3.67 },
  EUR: { symbol: '€', rate: 0.92 },
  GBP: { symbol: '£', rate: 0.78 },
};

function formatPrice(amountInUSD) {
  const conf = CURRENCY_RATES[currentCurrency] || CURRENCY_RATES.USD;
  const converted = (amountInUSD * conf.rate).toFixed(2);
  return `${conf.symbol}${converted}`;
}

// Categories list
const CATEGORIES = [
  'All',
  'Electronics & Mobile',
  'Men Clothing & Fashion',
  'Women Clothing & Fashion',
  'Home & Living',
  'Beauty & Care',
  'Accessories & Watches',
];

// Document Ready
document.addEventListener('DOMContentLoaded', () => {
  initCurrency();
  initCategories();
  initEventListeners();
  fetchProducts();
  renderCart();
  renderWishlist();
  checkAuthStatus();
  startFlashCountdown();
});

// ---------- Currency Management ----------
function initCurrency() {
  const select = document.getElementById('currencySelect');
  const mSelect = document.getElementById('mobileCurrencySelect');
  if (select) select.value = currentCurrency;
  if (mSelect) mSelect.value = currentCurrency;

  const handleCurrencyChange = (e) => {
    currentCurrency = e.target.value;
    localStorage.setItem('mz_currency', currentCurrency);
    if (select) select.value = currentCurrency;
    if (mSelect) mSelect.value = currentCurrency;
    renderProducts();
    renderFlashDeals();
    renderCart();
    renderWishlist();
    showToast(`Currency changed to ${currentCurrency}`, '💱');
  };

  if (select) select.addEventListener('change', handleCurrencyChange);
  if (mSelect) mSelect.addEventListener('change', handleCurrencyChange);
}

// ---------- Categories Navigation ----------
function initCategories() {
  const strip = document.getElementById('categoryStrip');
  const mobileList = document.getElementById('mobileCatList');

  if (strip) {
    strip.innerHTML = CATEGORIES.map(cat => `
      <button class="cat-pill ${cat === activeCategory ? 'active' : ''}" onclick="filterByCat('${cat}')">
        ${cat === 'All' ? '⚡ All Deals' : cat}
      </button>
    `).join('');
  }

  if (mobileList) {
    mobileList.innerHTML = CATEGORIES.map(cat => `
      <button class="mobile-cat-item" onclick="filterByCat('${cat}'); closeMobileMenu();">
        ${cat === 'All' ? '⚡ All Categories' : cat}
      </button>
    `).join('');
  }
}

window.filterByCat = function(cat) {
  activeCategory = cat;
  initCategories();
  const searchSelect = document.getElementById('searchCategorySelect');
  if (searchSelect) searchSelect.value = cat;
  const title = document.getElementById('catalogTitle');
  if (title) title.textContent = cat === 'All' ? 'Featured Products' : cat;
  renderProducts();
  scrollToCatalog();
};

window.scrollToCatalog = function() {
  const catalogEl = document.getElementById('catalog');
  if (catalogEl) {
    catalogEl.scrollIntoView({ behavior: 'smooth' });
  }
};

// ---------- Fetch Products from Backend ----------
async function fetchProducts() {
  try {
    const res = await fetch(`${API_BASE}/api/products`);
    const data = await res.json();
    if (data.products) {
      products = data.products;
      renderProducts();
      renderFlashDeals();
    }
  } catch (err) {
    console.error('Failed to load products from API:', err);
    showToast('Failed to load products from server', '⚠️');
  }
}

// ---------- Render Product Catalog ----------
function renderProducts() {
  const grid = document.getElementById('productsGrid');
  const countText = document.getElementById('productsCountText');
  if (!grid) return;

  let filtered = [...products];

  // Category filter
  if (activeCategory && activeCategory !== 'All') {
    filtered = filtered.filter(p => p.category && p.category.toLowerCase() === activeCategory.toLowerCase());
  }

  // Sorting
  const sortSelect = document.getElementById('sortSelect');
  const sortVal = sortSelect ? sortSelect.value : 'featured';
  if (sortVal === 'price-low') {
    filtered.sort((a, b) => a.price - b.price);
  } else if (sortVal === 'price-high') {
    filtered.sort((a, b) => b.price - a.price);
  } else if (sortVal === 'rating') {
    filtered.sort((a, b) => (b.rating || 0) - (a.rating || 0));
  } else if (sortVal === 'name') {
    filtered.sort((a, b) => a.name.localeCompare(b.name));
  }

  if (countText) {
    countText.textContent = `Showing ${filtered.length} products`;
  }

  if (filtered.length === 0) {
    grid.innerHTML = `
      <div class="loading-state">
        <p>No products found in this category.</p>
      </div>
    `;
    return;
  }

  grid.innerHTML = filtered.map(p => createProductCard(p)).join('');
}

function renderFlashDeals() {
  const grid = document.getElementById('flashDealsGrid');
  if (!grid) return;

  const deals = products.filter(p => p.isFlashDeal || p.badge);
  const displayDeals = deals.length > 0 ? deals.slice(0, 4) : products.slice(0, 4);

  grid.innerHTML = displayDeals.map(p => createProductCard(p)).join('');
}

function createProductCard(p) {
  const isWished = wishlist.some(w => w.id === p.id);
  const badgeHtml = p.badge ? `<span class="product-badge">${p.badge}</span>` : '';
  const origPriceHtml = p.originalPrice ? `<span class="product-price-orig">${formatPrice(p.originalPrice)}</span>` : '';

  return `
    <div class="product-card" data-id="${p.id}">
      <div class="product-card-img-wrap">
        <img src="${p.image || 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500'}" alt="${p.name}" loading="lazy">
        ${badgeHtml}
        <button class="product-fav-btn ${isWished ? 'active' : ''}" onclick="toggleWishlist(${p.id})" title="Wishlist">
          ${isWished ? '❤️' : '🤍'}
        </button>
      </div>
      <div class="product-card-body">
        <span class="product-cat">${p.category || 'General'}</span>
        <h4 class="product-title" title="${p.name}">${p.name}</h4>
        <div class="product-rating">
          ⭐ ${p.rating || '4.8'} <span>(${p.reviewsCount || 10})</span>
        </div>
        <div class="product-price-row">
          <span class="product-price-main">${formatPrice(p.price)}</span>
          ${origPriceHtml}
        </div>
        <div class="product-card-actions">
          <button class="btn btn-primary btn-card-add" onclick="addToCart(${p.id}, 1)">🛒 Add</button>
          <button class="btn-card-qv" onclick="openQuickView(${p.id})">👁️ Quick</button>
        </div>
      </div>
    </div>
  `;
}

// ---------- Quick View Modal ----------
window.openQuickView = function(productId) {
  const p = products.find(item => item.id === productId);
  if (!p) return;

  currentQvProduct = p;
  currentQvQty = 1;

  document.getElementById('qvImg').src = p.image || '';
  document.getElementById('qvBadge').textContent = p.badge || 'SPECIAL';
  document.getElementById('qvBadge').style.display = p.badge ? 'inline-block' : 'none';
  document.getElementById('qvCategory').textContent = p.category || '';
  document.getElementById('qvTitle').textContent = p.name || '';
  document.getElementById('qvRating').textContent = `⭐⭐⭐⭐⭐ ${p.rating || 4.9} (${p.reviewsCount || 50} verified reviews)`;
  document.getElementById('qvPrice').textContent = formatPrice(p.price);
  
  const origEl = document.getElementById('qvOrigPrice');
  const discEl = document.getElementById('qvDiscount');
  if (p.originalPrice && p.originalPrice > p.price) {
    origEl.textContent = formatPrice(p.originalPrice);
    const savePercent = Math.round(((p.originalPrice - p.price) / p.originalPrice) * 100);
    discEl.textContent = `SAVE ${savePercent}%`;
    discEl.style.display = 'inline-block';
  } else {
    origEl.textContent = '';
    discEl.style.display = 'none';
  }

  document.getElementById('qvDesc').textContent = p.description || 'Premium quality product designed for performance, comfort and style.';
  document.getElementById('qvStock').textContent = `In Stock (${p.stock || 10} units available)`;
  document.getElementById('qvQtyInput').value = 1;

  const modal = document.getElementById('quickViewModal');
  if (modal) modal.classList.add('active');
};

window.closeQuickView = function() {
  const modal = document.getElementById('quickViewModal');
  if (modal) modal.classList.remove('active');
};

window.adjustQvQty = function(delta) {
  currentQvQty = Math.max(1, currentQvQty + delta);
  const input = document.getElementById('qvQtyInput');
  if (input) input.value = currentQvQty;
};

// ---------- Cart Drawer & Operations ----------
window.addToCart = function(productId, qty = 1) {
  const p = products.find(item => item.id === productId);
  if (!p) return;

  const existing = cart.find(item => item.id === productId);
  if (existing) {
    existing.qty += qty;
  } else {
    cart.push({
      id: p.id,
      name: p.name,
      price: p.price,
      image: p.image,
      qty: qty,
    });
  }

  saveCart();
  renderCart();
  openCart();
  showToast(`Added ${qty} × ${p.name.slice(0, 20)}... to cart`, '🛍️');
};

window.updateCartQty = function(productId, delta) {
  const item = cart.find(i => i.id === productId);
  if (!item) return;

  item.qty += delta;
  if (item.qty <= 0) {
    cart = cart.filter(i => i.id !== productId);
  }
  saveCart();
  renderCart();
};

window.removeFromCart = function(productId) {
  cart = cart.filter(i => i.id !== productId);
  saveCart();
  renderCart();
  showToast('Item removed from cart', '🗑️');
};

function saveCart() {
  localStorage.setItem('mz_cart', JSON.stringify(cart));
}

function renderCart() {
  const totalCount = cart.reduce((sum, item) => sum + item.qty, 0);
  const rawSubtotal = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  // Update header badges
  const cBadge = document.getElementById('cartCount');
  const mBadge = document.getElementById('mCartCount');
  const dBadge = document.getElementById('cartDrawerCount');
  const headerTotal = document.getElementById('cartHeaderTotal');

  if (cBadge) cBadge.textContent = totalCount;
  if (mBadge) mBadge.textContent = totalCount;
  if (dBadge) dBadge.textContent = totalCount;
  if (headerTotal) headerTotal.textContent = formatPrice(rawSubtotal);

  // Render items
  const itemsContainer = document.getElementById('cartItems');
  if (!itemsContainer) return;

  if (cart.length === 0) {
    itemsContainer.innerHTML = `
      <div class="empty-drawer-state">
        <span class="empty-icon">🛒</span>
        <h4>Your cart is empty</h4>
        <p>Explore our latest products and add them to your cart!</p>
        <button class="btn btn-primary" onclick="closeCart(); scrollToCatalog();">Start Shopping</button>
      </div>
    `;
  } else {
    itemsContainer.innerHTML = cart.map(item => `
      <div class="cart-item-row">
        <img class="cart-item-img" src="${item.image || ''}" alt="${item.name}">
        <div class="cart-item-details">
          <h4 class="cart-item-title">${item.name}</h4>
          <div class="cart-item-price">${formatPrice(item.price)}</div>
          <div class="cart-item-controls">
            <button class="cart-qty-btn" onclick="updateCartQty(${item.id}, -1)">−</button>
            <span class="cart-qty-val">${item.qty}</span>
            <button class="cart-qty-btn" onclick="updateCartQty(${item.id}, 1)">+</button>
            <button class="cart-item-remove" onclick="removeFromCart(${item.id})">Remove</button>
          </div>
        </div>
      </div>
    `).join('');
  }

  // Calculate discounts and totals
  let discountAmount = 0;
  if (appliedDiscount && appliedDiscount.percent) {
    discountAmount = (rawSubtotal * appliedDiscount.percent) / 100;
  }

  const finalTotal = Math.max(0, rawSubtotal - discountAmount);

  const subtotalEl = document.getElementById('cartSubtotal');
  const totalEl = document.getElementById('cartTotal');
  const discRow = document.getElementById('cartDiscountRow');
  const discAmountEl = document.getElementById('cartDiscountAmount');
  const discNameEl = document.getElementById('discountName');

  if (subtotalEl) subtotalEl.textContent = formatPrice(rawSubtotal);
  if (totalEl) totalEl.textContent = formatPrice(finalTotal);

  if (discountAmount > 0) {
    if (discRow) discRow.style.display = 'flex';
    if (discNameEl) discNameEl.textContent = appliedDiscount.code;
    if (discAmountEl) discAmountEl.textContent = `- ${formatPrice(discountAmount)}`;
  } else {
    if (discRow) discRow.style.display = 'none';
  }
}

window.openCart = function() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.add('active');
};

window.closeCart = function() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.remove('active');
};

// ---------- Coupon Application ----------
window.applyCoupon = function() {
  const input = document.getElementById('cartCouponInput');
  const status = document.getElementById('couponStatusText');
  if (!input) return;

  const code = input.value.trim().toUpperCase();
  if (!code) return;

  if (code === 'WELCOME15') {
    appliedDiscount = { code: 'WELCOME15 (15% OFF)', percent: 15 };
    if (status) {
      status.style.color = 'var(--success)';
      status.textContent = '🎉 15% discount applied successfully!';
    }
  } else if (code === 'MODZONE10') {
    appliedDiscount = { code: 'MODZONE10 (10% OFF)', percent: 10 };
    if (status) {
      status.style.color = 'var(--success)';
      status.textContent = '🎉 10% discount applied successfully!';
    }
  } else {
    if (status) {
      status.style.color = 'var(--red)';
      status.textContent = '❌ Invalid or expired coupon code.';
    }
    return;
  }
  renderCart();
};

// ---------- Wishlist Operations ----------
window.toggleWishlist = function(productId) {
  const p = products.find(item => item.id === productId);
  if (!p) return;

  const idx = wishlist.findIndex(item => item.id === productId);
  if (idx !== -1) {
    wishlist.splice(idx, 1);
    showToast('Removed from saved items', '🤍');
  } else {
    wishlist.push(p);
    showToast('Saved to your wishlist!', '❤️');
  }

  saveWishlist();
  renderWishlist();
  renderProducts();
  renderFlashDeals();
};

function saveWishlist() {
  localStorage.setItem('mz_wishlist', JSON.stringify(wishlist));
}

function renderWishlist() {
  const count = wishlist.length;
  const wBadge = document.getElementById('wishlistCount');
  const mWBadge = document.getElementById('mWishlistCount');
  const dBadge = document.getElementById('wishlistDrawerCount');

  if (wBadge) wBadge.textContent = count;
  if (mWBadge) mWBadge.textContent = count;
  if (dBadge) dBadge.textContent = count;

  const container = document.getElementById('wishlistItems');
  if (!container) return;

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="empty-drawer-state">
        <span class="empty-icon">❤️</span>
        <h4>Your wishlist is empty</h4>
        <p>Save items you love to revisit anytime!</p>
        <button class="btn btn-primary" onclick="closeWishlist(); scrollToCatalog();">Browse Catalog</button>
      </div>
    `;
  } else {
    container.innerHTML = wishlist.map(item => `
      <div class="wishlist-item-row">
        <img class="cart-item-img" src="${item.image || ''}" alt="${item.name}">
        <div class="cart-item-details">
          <h4 class="cart-item-title">${item.name}</h4>
          <div class="cart-item-price">${formatPrice(item.price)}</div>
          <div class="cart-item-controls">
            <button class="btn btn-primary btn-sm" onclick="addToCart(${item.id}, 1); toggleWishlist(${item.id});" style="padding:4px 10px; font-size:12px;">Move to Cart</button>
            <button class="cart-item-remove" onclick="toggleWishlist(${item.id})">Remove</button>
          </div>
        </div>
      </div>
    `).join('');
  }
}

window.openWishlist = function() {
  const drawer = document.getElementById('wishlistDrawer');
  if (drawer) drawer.classList.add('active');
};

window.closeWishlist = function() {
  const drawer = document.getElementById('wishlistDrawer');
  if (drawer) drawer.classList.remove('active');
};

// ---------- Mobile Drawer Menu ----------
window.openMobileMenu = function() {
  const drawer = document.getElementById('mobileDrawer');
  if (drawer) drawer.classList.add('active');
};

window.closeMobileMenu = function() {
  const drawer = document.getElementById('mobileDrawer');
  if (drawer) drawer.classList.remove('active');
};

// ---------- Checkout Flow ----------
window.openCheckout = function() {
  if (cart.length === 0) {
    showToast('Your cart is empty! Add products first.', '⚠️');
    return;
  }
  closeCart();

  // Populate user data if logged in
  const user = JSON.parse(localStorage.getItem('mz_customer') || 'null');
  if (user) {
    if (document.getElementById('orderName')) document.getElementById('orderName').value = user.name || '';
    if (document.getElementById('orderEmail')) document.getElementById('orderEmail').value = user.email || '';
    if (document.getElementById('orderPhone')) document.getElementById('orderPhone').value = user.phone || '';
    if (document.getElementById('orderAddress')) document.getElementById('orderAddress').value = user.address || '';
  }

  // Populate order summary
  const summaryBox = document.getElementById('checkoutSummaryBox');
  if (summaryBox) {
    const rawSubtotal = cart.reduce((sum, i) => sum + i.price * i.qty, 0);
    let discountAmount = 0;
    if (appliedDiscount) discountAmount = (rawSubtotal * appliedDiscount.percent) / 100;
    const finalTotal = Math.max(0, rawSubtotal - discountAmount);

    summaryBox.innerHTML = `
      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span>Items (${cart.reduce((s, i) => s + i.qty, 0)}):</span>
        <strong>${formatPrice(rawSubtotal)}</strong>
      </div>
      ${discountAmount > 0 ? `
        <div style="display:flex; justify-content:space-between; margin-bottom:6px; color:var(--success);">
          <span>Discount (${appliedDiscount.code}):</span>
          <strong>- ${formatPrice(discountAmount)}</strong>
        </div>
      ` : ''}
      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span>Shipping:</span>
        <strong style="color:var(--success);">FREE</strong>
      </div>
      <div style="display:flex; justify-content:space-between; border-top:1px solid var(--border-color); padding-top:8px; font-size:15px;">
        <span>Order Total:</span>
        <strong style="color:var(--primary); font-size:17px;">${formatPrice(finalTotal)}</strong>
      </div>
    `;
  }

  const modal = document.getElementById('checkoutModal');
  if (modal) modal.classList.add('active');
};

window.closeCheckout = function() {
  const modal = document.getElementById('checkoutModal');
  if (modal) modal.classList.remove('active');
};

// ---------- Auth Modal & Customer API ----------
window.triggerAccountModal = function() {
  const token = localStorage.getItem('mz_token');
  const modal = document.getElementById('authModal');
  if (!modal) return;

  if (token) {
    showProfileView();
  } else {
    showLoginForm();
  }
  modal.classList.add('active');
};

window.closeAuthModal = function() {
  const modal = document.getElementById('authModal');
  if (modal) modal.classList.remove('active');
};

function showLoginForm() {
  document.getElementById('authTabs').style.display = 'flex';
  document.getElementById('loginForm').classList.remove('hidden');
  document.getElementById('registerForm').classList.add('hidden');
  document.getElementById('profileView').classList.add('hidden');
  document.querySelectorAll('.auth-tabs .tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelector('.auth-tabs .tab-btn[data-tab="login"]').classList.add('active');
}

function showRegisterForm() {
  document.getElementById('authTabs').style.display = 'flex';
  document.getElementById('loginForm').classList.add('hidden');
  document.getElementById('registerForm').classList.remove('hidden');
  document.getElementById('profileView').classList.add('hidden');
  document.querySelectorAll('.auth-tabs .tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelector('.auth-tabs .tab-btn[data-tab="register"]').classList.add('active');
}

function showProfileView() {
  const user = JSON.parse(localStorage.getItem('mz_customer') || '{}');
  document.getElementById('authTabs').style.display = 'none';
  document.getElementById('loginForm').classList.add('hidden');
  document.getElementById('registerForm').classList.add('hidden');
  document.getElementById('profileView').classList.remove('hidden');

  document.getElementById('profileName').textContent = user.name || 'Customer';
  document.getElementById('profileEmail').textContent = user.email || '';
  document.getElementById('profilePhone').textContent = user.phone || 'Not provided';
  document.getElementById('profileAddress').textContent = user.address || 'Not provided';
  document.getElementById('profileInitials').textContent = (user.name ? user.name[0] : 'U').toUpperCase();

  fetchCustomerOrders();
}

async function fetchCustomerOrders() {
  const token = localStorage.getItem('mz_token');
  if (!token) return;
  try {
    const res = await fetch(`${API_BASE}/api/customer/orders`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (data.orders) {
      document.getElementById('profileOrdersCount').textContent = `${data.orders.length} orders placed`;
    }
  } catch (e) {
    console.error(e);
  }
}

function checkAuthStatus() {
  const user = JSON.parse(localStorage.getItem('mz_customer') || 'null');
  const greeting = document.getElementById('userGreeting');
  const mobileName = document.getElementById('mobileUserName');
  const mobileStatus = document.getElementById('mobileUserStatus');

  if (user) {
    if (greeting) greeting.textContent = user.name.split(' ')[0];
    if (mobileName) mobileName.textContent = user.name;
    if (mobileStatus) mobileStatus.textContent = 'Verified Customer (Tap to view account)';
  } else {
    if (greeting) greeting.textContent = 'Account';
    if (mobileName) mobileName.textContent = 'Welcome, Guest';
    if (mobileStatus) mobileStatus.textContent = 'Tap to sign in or register';
  }
}

// ---------- Order Tracking Flow ----------
window.openTrackOrderModal = function() {
  const modal = document.getElementById('trackOrderModal');
  if (modal) modal.classList.add('active');
};

window.closeTrackOrderModal = function() {
  const modal = document.getElementById('trackOrderModal');
  if (modal) modal.classList.remove('active');
};

async function trackOrder(orderId) {
  const resultBox = document.getElementById('trackResultBox');
  if (!resultBox) return;

  resultBox.style.display = 'block';
  resultBox.innerHTML = '<div class="spinner" style="margin: 20px auto;"></div>';

  try {
    const res = await fetch(`${API_BASE}/api/orders/track?id=${encodeURIComponent(orderId)}`);
    const data = await res.json();

    if (!res.ok || !data.order) {
      resultBox.innerHTML = `
        <div style="color:var(--red); padding:10px 0;">
          ❌ No order found matching "<strong>${orderId}</strong>". Please check your Order ID.
        </div>
      `;
      return;
    }

    const o = data.order;
    const statusMap = {
      pending: 1,
      processing: 2,
      shipped: 3,
      delivered: 4,
    };
    const currentStep = statusMap[o.status] || 1;

    resultBox.innerHTML = `
      <div style="margin-bottom:12px; border-bottom:1px solid var(--border-color); padding-bottom:8px;">
        <div style="display:flex; justify-content:space-between;">
          <strong>Order: ${o.orderNumber}</strong>
          <span style="color:var(--primary); font-weight:700; text-transform:uppercase;">${o.status}</span>
        </div>
        <small style="color:var(--text-muted);">Customer: ${o.customerName} • Items: ${o.itemsCount}</small>
      </div>
      <div class="track-timeline">
        <div class="timeline-step ${currentStep >= 1 ? (currentStep === 1 ? 'active' : 'completed') : ''}">
          <strong>Order Placed</strong>
          <p style="color:var(--text-muted); font-size:11px;">We received your order and payment info.</p>
        </div>
        <div class="timeline-step ${currentStep >= 2 ? (currentStep === 2 ? 'active' : 'completed') : ''}">
          <strong>Processing in Warehouse</strong>
          <p style="color:var(--text-muted); font-size:11px;">Items verified, quality checked and boxed.</p>
        </div>
        <div class="timeline-step ${currentStep >= 3 ? (currentStep === 3 ? 'active' : 'completed') : ''}">
          <strong>Out for Delivery</strong>
          <p style="color:var(--text-muted); font-size:11px;">Handed over to courier with express transit.</p>
        </div>
        <div class="timeline-step ${currentStep >= 4 ? 'completed' : ''}">
          <strong>Delivered</strong>
          <p style="color:var(--text-muted); font-size:11px;">Package handed over to recipient.</p>
        </div>
      </div>
    `;
  } catch (err) {
    resultBox.innerHTML = '<div style="color:var(--red);">Failed to fetch tracking details. Please try again.</div>';
  }
}

// ---------- Carousel Slide Switcher ----------
let activeHeroIndex = 0;
window.switchHeroSlide = function(index) {
  const slides = document.querySelectorAll('.carousel-slide');
  const dots = document.querySelectorAll('.carousel-dots .dot');
  if (slides.length === 0) return;

  slides.forEach((s, i) => {
    s.classList.toggle('active', i === index);
  });
  dots.forEach((d, i) => {
    d.classList.toggle('active', i === index);
  });
  activeHeroIndex = index;
};

// Automatic hero slide carousel
setInterval(() => {
  const slides = document.querySelectorAll('.carousel-slide');
  if (slides.length > 1) {
    switchHeroSlide((activeHeroIndex + 1) % slides.length);
  }
}, 6000);

// ---------- Flash Deals Countdown Timer ----------
function startFlashCountdown() {
  let seconds = 8 * 3600 + 45 * 60 + 20;
  setInterval(() => {
    seconds = Math.max(0, seconds - 1);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    const elH = document.getElementById('timerHours');
    const elM = document.getElementById('timerMinutes');
    const elS = document.getElementById('timerSeconds');

    if (elH) elH.textContent = String(h).padStart(2, '0');
    if (elM) elM.textContent = String(m).padStart(2, '0');
    if (elS) elS.textContent = String(s).padStart(2, '0');
  }, 1000);
}

// ---------- Toast Notification ----------
window.showToast = function(msg, icon = '✅') {
  const toast = document.getElementById('toast');
  if (!toast) return;

  toast.innerHTML = `<span>${icon}</span> <span>${msg}</span>`;
  toast.classList.add('active');

  clearTimeout(window.toastTimer);
  window.toastTimer = setTimeout(() => {
    toast.classList.remove('active');
  }, 3500);
};

// ---------- Event Listeners Setup ----------
function initEventListeners() {
  // Mobile drawer
  const mBtn = document.getElementById('mobileMenuBtn');
  const closeMBtn = document.getElementById('closeMobileDrawer');
  const mBackdrop = document.getElementById('mobileDrawerBackdrop');
  if (mBtn) mBtn.addEventListener('click', openMobileMenu);
  if (closeMBtn) closeMBtn.addEventListener('click', closeMobileMenu);
  if (mBackdrop) mBackdrop.addEventListener('click', closeMobileMenu);

  // Cart
  const cartBtn = document.getElementById('cartBtn');
  const mCartBtn = document.getElementById('mobileCartBtn');
  const closeCartBtn = document.getElementById('closeCart');
  const cartBackdrop = document.getElementById('cartBackdrop');
  const checkoutBtn = document.getElementById('checkoutBtn');

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (mCartBtn) mCartBtn.addEventListener('click', () => { closeMobileMenu(); openCart(); });
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);
  if (checkoutBtn) checkoutBtn.addEventListener('click', openCheckout);

  // Coupon
  const applyCouponBtn = document.getElementById('applyCouponBtn');
  if (applyCouponBtn) applyCouponBtn.addEventListener('click', applyCoupon);

  // Wishlist
  const wishBtn = document.getElementById('wishlistBtn');
  const mWishBtn = document.getElementById('mobileWishlistBtn');
  const closeWishBtn = document.getElementById('closeWishlist');
  const wishBackdrop = document.getElementById('wishlistBackdrop');

  if (wishBtn) wishBtn.addEventListener('click', openWishlist);
  if (mWishBtn) mWishBtn.addEventListener('click', () => { closeMobileMenu(); openWishlist(); });
  if (closeWishBtn) closeWishBtn.addEventListener('click', closeWishlist);
  if (wishBackdrop) wishBackdrop.addEventListener('click', closeWishlist);

  // Quickview
  const closeQv = document.getElementById('closeQuickView');
  const qvBackdrop = document.getElementById('quickViewBackdrop');
  const qvAddBtn = document.getElementById('qvAddToCartBtn');
  const qvWishBtn = document.getElementById('qvWishlistBtn');

  if (closeQv) closeQv.addEventListener('click', closeQuickView);
  if (qvBackdrop) qvBackdrop.addEventListener('click', closeQuickView);
  if (qvAddBtn) {
    qvAddBtn.addEventListener('click', () => {
      if (currentQvProduct) {
        addToCart(currentQvProduct.id, currentQvQty);
        closeQuickView();
      }
    });
  }
  if (qvWishBtn) {
    qvWishBtn.addEventListener('click', () => {
      if (currentQvProduct) toggleWishlist(currentQvProduct.id);
    });
  }

  // Account
  const accountBtn = document.getElementById('accountBtn');
  const mobileUserSnippet = document.getElementById('mobileUserSnippet');
  const closeAuth = document.getElementById('closeAuth');
  const authBackdrop = document.getElementById('authBackdrop');
  const logoutBtn = document.getElementById('logoutBtn');

  if (accountBtn) accountBtn.addEventListener('click', triggerAccountModal);
  if (mobileUserSnippet) mobileUserSnippet.addEventListener('click', () => { closeMobileMenu(); triggerAccountModal(); });
  if (closeAuth) closeAuth.addEventListener('click', closeAuthModal);
  if (authBackdrop) authBackdrop.addEventListener('click', closeAuthModal);

  if (logoutBtn) {
    logoutBtn.addEventListener('click', () => {
      localStorage.removeItem('mz_token');
      localStorage.removeItem('mz_customer');
      checkAuthStatus();
      closeAuthModal();
      showToast('Logged out successfully', '👋');
    });
  }

  // Auth tabs
  document.querySelectorAll('.auth-tabs .tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.tab === 'login') showLoginForm();
      else showRegisterForm();
    });
  });

  // Login form submission
  const loginForm = document.getElementById('loginForm');
  if (loginForm) {
    loginForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const msg = document.getElementById('loginMsg');
      msg.textContent = 'Logging in...';
      msg.style.color = 'var(--text-muted)';

      try {
        const res = await fetch(`${API_BASE}/api/customer/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: document.getElementById('loginEmail').value,
            password: document.getElementById('loginPassword').value,
          })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Login failed');

        localStorage.setItem('mz_token', data.token);
        localStorage.setItem('mz_customer', JSON.stringify(data.user));
        msg.textContent = 'Success!';
        msg.style.color = 'var(--success)';
        checkAuthStatus();
        setTimeout(closeAuthModal, 800);
        showToast(`Welcome back, ${data.user.name}!`, '🎉');
      } catch (err) {
        msg.textContent = err.message;
        msg.style.color = 'var(--red)';
      }
    });
  }

  // Register form submission
  const registerForm = document.getElementById('registerForm');
  if (registerForm) {
    registerForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const msg = document.getElementById('regMsg');
      msg.textContent = 'Creating account...';
      msg.style.color = 'var(--text-muted)';

      try {
        const res = await fetch(`${API_BASE}/api/customer/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: document.getElementById('regName').value,
            email: document.getElementById('regEmail').value,
            password: document.getElementById('regPassword').value,
            phone: document.getElementById('regPhone').value,
            address: document.getElementById('regAddress').value,
          })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Registration failed');

        localStorage.setItem('mz_token', data.token);
        localStorage.setItem('mz_customer', JSON.stringify(data.user));
        msg.textContent = 'Account created!';
        msg.style.color = 'var(--success)';
        checkAuthStatus();
        setTimeout(closeAuthModal, 800);
        showToast(`Welcome to MODZONE, ${data.user.name}!`, '🎉');
      } catch (err) {
        msg.textContent = err.message;
        msg.style.color = 'var(--red)';
      }
    });
  }

  // Checkout form
  const checkoutForm = document.getElementById('checkoutForm');
  const closeCheckoutBtn = document.getElementById('closeCheckout');
  const checkoutBackdrop = document.getElementById('checkoutBackdrop');

  if (closeCheckoutBtn) closeCheckoutBtn.addEventListener('click', closeCheckout);
  if (checkoutBackdrop) checkoutBackdrop.addEventListener('click', closeCheckout);

  // Payment radio selectors
  document.querySelectorAll('input[name="payMethod"]').forEach(radio => {
    radio.addEventListener('change', () => {
      document.querySelectorAll('.pay-option').forEach(l => l.classList.remove('selected'));
      radio.closest('.pay-option').classList.add('selected');
    });
  });

  if (checkoutForm) {
    checkoutForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = document.getElementById('placeOrderBtn');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing Order... ⏳';

      const rawSubtotal = cart.reduce((sum, i) => sum + i.price * i.qty, 0);
      let discountAmount = 0;
      if (appliedDiscount) discountAmount = (rawSubtotal * appliedDiscount.percent) / 100;
      const finalTotal = Math.max(0, rawSubtotal - discountAmount);
      const selectedPay = document.querySelector('input[name="payMethod"]:checked').value;

      const orderPayload = {
        customerName: document.getElementById('orderName').value,
        customerEmail: document.getElementById('orderEmail').value,
        customerPhone: document.getElementById('orderPhone').value,
        shippingAddress: document.getElementById('orderAddress').value,
        paymentMethod: selectedPay === 'COD' ? 'Cash on Delivery' : 'Online Debit/Credit Card',
        items: cart,
        subtotal: rawSubtotal,
        discount: discountAmount,
        total: finalTotal,
      };

      try {
        const token = localStorage.getItem('mz_token');
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(`${API_BASE}/api/orders`, {
          method: 'POST',
          headers,
          body: JSON.stringify(orderPayload),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to place order');

        // Order succeeded
        cart = [];
        saveCart();
        renderCart();
        closeCheckout();

        // Show Success modal
        const successModal = document.getElementById('orderSuccessModal');
        const detailsEl = document.getElementById('successOrderDetails');
        if (detailsEl) {
          detailsEl.innerHTML = `
            <div style="margin-bottom:8px;"><strong>Order ID:</strong> ${data.order.orderNumber || ('MZ-' + data.order.id)}</div>
            <div style="margin-bottom:8px;"><strong>Recipient:</strong> ${data.order.customerName}</div>
            <div style="margin-bottom:8px;"><strong>Delivery To:</strong> ${data.order.shippingAddress}</div>
            <div style="margin-bottom:8px;"><strong>Payment:</strong> ${data.order.paymentMethod}</div>
            <div><strong>Total Paid/Due:</strong> <span style="color:var(--primary); font-weight:700;">${formatPrice(data.order.total)}</span></div>
          `;
        }
        if (successModal) successModal.classList.add('active');

        // Store last placed order ID for tracking
        window.lastPlacedOrderId = data.order.orderNumber || data.order.id;

      } catch (err) {
        showToast(err.message, '❌');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Confirm & Place Order 🎉';
      }
    });
  }

  // Success modal buttons
  const continueShoppingBtn = document.getElementById('continueShoppingBtn');
  const trackRecentOrderBtn = document.getElementById('trackRecentOrderBtn');
  const orderSuccessModal = document.getElementById('orderSuccessModal');
  const orderSuccessBackdrop = document.getElementById('orderSuccessBackdrop');

  if (continueShoppingBtn) {
    continueShoppingBtn.addEventListener('click', () => {
      if (orderSuccessModal) orderSuccessModal.classList.remove('active');
      scrollToCatalog();
    });
  }
  if (orderSuccessBackdrop) {
    orderSuccessBackdrop.addEventListener('click', () => {
      if (orderSuccessModal) orderSuccessModal.classList.remove('active');
    });
  }
  if (trackRecentOrderBtn) {
    trackRecentOrderBtn.addEventListener('click', () => {
      if (orderSuccessModal) orderSuccessModal.classList.remove('active');
      openTrackOrderModal();
      if (window.lastPlacedOrderId) {
        document.getElementById('trackInput').value = window.lastPlacedOrderId;
        trackOrder(window.lastPlacedOrderId);
      }
    });
  }

  // Tracking modal handlers
  const topTrackBtn = document.getElementById('topTrackBtn');
  const navTrackBtn = document.getElementById('navTrackBtn');
  const mTrackBtn = document.getElementById('mobileTrackOrderBtn');
  const footerTrackBtn = document.getElementById('footerTrackBtn');
  const closeTrack = document.getElementById('closeTrackOrder');
  const trackBackdrop = document.getElementById('trackOrderBackdrop');
  const trackSubmitBtn = document.getElementById('trackSubmitBtn');

  [topTrackBtn, navTrackBtn, footerTrackBtn].forEach(btn => {
    if (btn) btn.addEventListener('click', openTrackOrderModal);
  });
  if (mTrackBtn) {
    mTrackBtn.addEventListener('click', () => {
      closeMobileMenu();
      openTrackOrderModal();
    });
  }
  if (closeTrack) closeTrack.addEventListener('click', closeTrackOrderModal);
  if (trackBackdrop) trackBackdrop.addEventListener('click', closeTrackOrderModal);

  if (trackSubmitBtn) {
    trackSubmitBtn.addEventListener('click', () => {
      const val = document.getElementById('trackInput').value.trim();
      if (val) trackOrder(val);
      else showToast('Please enter an Order ID', '⚠️');
    });
  }

  // Search Bar
  const searchBtn = document.getElementById('searchBtn');
  const searchInput = document.getElementById('searchInput');
  const searchCat = document.getElementById('searchCategorySelect');

  const executeSearch = () => {
    const q = searchInput ? searchInput.value.trim() : '';
    const cat = searchCat ? searchCat.value : 'All';
    activeCategory = cat;
    initCategories();

    let filtered = [...products];
    if (cat && cat !== 'All') {
      filtered = filtered.filter(p => p.category && p.category.toLowerCase() === cat.toLowerCase());
    }
    if (q) {
      const query = q.toLowerCase();
      filtered = filtered.filter(p =>
        (p.name && p.name.toLowerCase().includes(query)) ||
        (p.description && p.description.toLowerCase().includes(query)) ||
        (p.brand && p.brand.toLowerCase().includes(query))
      );
    }

    const grid = document.getElementById('productsGrid');
    const title = document.getElementById('catalogTitle');
    const countText = document.getElementById('productsCountText');

    if (title) title.textContent = q ? `Search Results for "${q}"` : (cat === 'All' ? 'Featured Products' : cat);
    if (countText) countText.textContent = `Found ${filtered.length} products`;

    if (grid) {
      if (filtered.length === 0) {
        grid.innerHTML = `
          <div class="loading-state">
            <p>No products match your search criteria.</p>
          </div>
        `;
      } else {
        grid.innerHTML = filtered.map(p => createProductCard(p)).join('');
      }
    }
    scrollToCatalog();
  };

  if (searchBtn) searchBtn.addEventListener('click', executeSearch);
  if (searchInput) {
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') executeSearch();
    });
  }
  if (searchCat) {
    searchCat.addEventListener('change', () => {
      activeCategory = searchCat.value;
      initCategories();
      executeSearch();
    });
  }

  // Sorting
  const sortSelect = document.getElementById('sortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', renderProducts);
  }

  // Newsletter
  const newsForm = document.getElementById('newsletterForm');
  if (newsForm) {
    newsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = document.getElementById('newsEmail').value;
      showToast(`Subscribed! Use code WELCOME15 for $15 OFF`, '🎁');
      newsForm.reset();
    });
  }
}
